"use strict";

class Slider extends Widget {
    _element: any;
    _text: any;
    _input: any;

    constructor(element: any) {
        super(element);

        let text = this._element.text();
        this._text = $('<div class="text">' + text + "</div>");
        this._input = $('<input type="range" min="0" max="100" />');
        this._element.html("");
        this._element.append(this._text);
        this._element.append(this._input);

        this._input.change(this._onChanged.bind(this));
    }

    text(text: any) {
        if (text === undefined) {
            return this._text.text();
        } else {
            this._text.text(text);
        }
    }

    // active(active: any) {
    //     if (active === undefined) {
    //         return this._element.hasClass("active");
    //     } else if (active !== this.active()) {
    //         this._element.toggleClass("active");
    //     }
    // }

    // click() {
    //     this._onClicked();
    // }

    // _onClicked() {
    //     this.emit("clicked");
    // }

    change() {
        this._onChanged();
    }

    _onChanged() {
        this.emit("change");
    }

    value(value: any) {
        if (value === undefined) {
            return this._input.val();
        } else {
            this._input.val(value);
            this._text.text(value + "%");
        }
    }

    static Create() {
        return $(
            '<div class="text"></div> <input type="range" min="0" max="100" />'
        );
    }
}

ui.Slider = Slider;
ui.slider = ui.widgetConstructor("slider", ui.Slider);
